import type {
  TaskExecutionStatus,
  TaskRequestForm,
  TaskRequestStatusFilter,
  TaskWorkType,
} from '@/features/task-assignment/types/taskAssignment';
import { cva } from 'class-variance-authority';

export const TASK_ASSIGNMENT_KEY = 'task-assignment';
export const TASK_REQUEST_PAGE_SIZE = 100;
export const TASK_ASSIGNEE_CAPACITY = 100;

/** Placeholder rows drawn by the task-request list skeleton before the first page lands. */
export const TASK_REQUEST_SKELETON_ROWS = 8;

export const TASK_WORK_TYPES: readonly TaskWorkType[] = [
  'asset.annotate',
  'asset.segment.clip',
  'asset.review',
];

export const TASK_REQUEST_STATUS_FILTERS: readonly TaskRequestStatusFilter[] = [
  'open',
  'closed',
  'cancelled',
  'all',
];

export const ACTIVE_TASK_EXECUTION_STATUSES: readonly TaskExecutionStatus[] = [
  'assigned',
  'in_progress',
];

export const INITIAL_TASK_REQUEST_FORM: TaskRequestForm = {
  projectId: '',
  workTypeId: 'asset.annotate',
  title: '',
  instructions: '',
  sourceAssetId: '',
  annotationId: '',
};

export const taskAssetOptionVariants = cva(
  'absolute left-0 h-auto min-h-10 w-full justify-start rounded-none px-3 py-1.5 text-left',
  {
    variants: { selected: { true: 'bg-accent', false: null } },
    defaultVariants: { selected: false },
  },
);

export const taskWorkTypeTriggerVariants = cva('justify-between font-normal', {
  variants: { populated: { true: null, false: 'text-muted-foreground' } },
  defaultVariants: { populated: false },
});
